package fr.manyverse.app.domain.model

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@OptIn(ExperimentalSerializationApi::class)
@Serializable
data class PreMadeCharacterToUpdate(
    @SerialName("name")
    val name: String,

    @SerialName("story")
    val story: String,

    // EncodeDefault.ALWAYS: sans ça, image_url=null est omis du PATCH et la colonne garde l'ancienne valeur (avatar supprimé non répercuté).
    @EncodeDefault(EncodeDefault.Mode.ALWAYS)
    @SerialName("image_url")
    val imageUrl: String? = null,

    // EncodeDefault.ALWAYS: garantit l'envoi du PATCH même quand la fiche est vide (réinitialise la colonne).
    @EncodeDefault(EncodeDefault.Mode.ALWAYS)
    @SerialName("sheet")
    val sheet: CharacterSheet = CharacterSheet(),

    // EncodeDefault.ALWAYS: garantit l'envoi du PATCH même quand l'inventaire est vide (réinitialise la colonne).
    @EncodeDefault(EncodeDefault.Mode.ALWAYS)
    @SerialName("inventory")
    val inventory: List<PreMadeInventoryItem> = emptyList()
)
